import React, { useEffect, useState } from "react";
import { LayersControl, LayerGroup, TileLayer } from "react-leaflet";
import { MarkersCrossroad } from "../markers/crossroad/Markers";
import { MarkersSpeed } from "../markers/speed/Markers";
import { MarkersParking } from "../markers/parking/Markers";
import { MarkersDeactivated } from "../markers/deactivated/Markers";
import { MarkersVgk } from "../markers/vgk/Markers";
import { ComplexesContext } from "../../context";
import { useContext } from "react";
import { MarkersVehicle } from "../markers/vehicle/Markers";
const { BaseLayer } = LayersControl


const baseLayers = {
    twogis: "https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1.1",
    osm: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    arc: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    google: 'https://mt1.google.com/vt/lyrs=m@169000000&hl=ru&x={x}&y={y}&z={z}',
    yandex: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=21.06.04-0-b210520094930&x={x}&y={y}&z={z}&scale=1&lang=ru',
    gurtam: 'https://gps.vrplus.ru/gis_vector/{x}_{y}_{z}/4700/tile.pbf'
}






const ControlLayer = (props) => {
    const { complexesPayload } = useContext(ComplexesContext)
    const { hosts, vehicles } = complexesPayload
    // console.log(hosts)

    // Функция для инициализации состояний из localStorage
    const getInitialLayers = () => {
        return {
            base_layer: parseInt(localStorage.getItem('base_layer') || '1'),
            layer_crossroad: parseInt(localStorage.getItem('layer_crossroad') || '1'),
            layer_speed: parseInt(localStorage.getItem('layer_speed') || '1'),
            layer_parking: parseInt(localStorage.getItem('layer_parking') || '1'),
            layer_vgk: parseInt(localStorage.getItem('layer_vgk') || '1'),
            layer_deact: parseInt(localStorage.getItem('layer_deact') || '0'),
            layer_vehicles: parseInt(localStorage.getItem('layer_vehicles') || '1')
        }
    }

    // Состояния слоев
    const [layers, setLayers] = useState(getInitialLayers)

    // Функция для сохранения состояния слоя
    const saveLayerState = (layerName, value) => {
        localStorage.setItem(layerName, value.toString())
        setLayers(prev => ({
            ...prev,
            [layerName]: value
        }))
    }

    // Инициализация при монтировании компонента
    useEffect(() => {
        // Устанавливаем значения по умолчанию, если их нет
        const defaults = {
            base_layer: 1,
            layer_crossroad: 1,
            layer_speed: 1,
            layer_parking: 1,
            layer_vgk: 1,
            layer_deact: 0,
            layer_vehicles: 1
        }

        Object.entries(defaults).forEach(([key, value]) => {
            if (localStorage.getItem(key) === null) {
                localStorage.setItem(key, value.toString())
            }
        })
    }, [])



    return (

        <LayersControl position="topright" collapsed={true}>
            <BaseLayer checked={layers.base_layer === 1} name="OSM">
                <TileLayer url={baseLayers.osm} eventHandlers={{
                    add: (e) => { saveLayerState('base_layer', 1) }
                }} keepBuffer={3} />
            </BaseLayer>
            <BaseLayer checked={layers.base_layer === 2} name="2GIS" >
                <TileLayer url={baseLayers.twogis} eventHandlers={{
                    add: (e) => { saveLayerState('base_layer', 2) }
                }} keepBuffer={3} />
            </BaseLayer>
            <BaseLayer checked={layers.base_layer === 3} name="Google">
                <TileLayer url={baseLayers.google} eventHandlers={{
                    add: (e) => { saveLayerState('base_layer', 3) }
                }} keepBuffer={3} />
            </BaseLayer>
            <BaseLayer checked={layers.base_layer === 4} name="ArcGis">
                <TileLayer url={baseLayers.arc} eventHandlers={{
                    add: (e) => { saveLayerState('base_layer', 4) }
                }} keepBuffer={3} />
            </BaseLayer>






            <LayersControl.Overlay name="Перекрестки" checked={layers.layer_crossroad === 1 || props.roles?.includes('cafap_cr')}>
                <LayerGroup eventHandlers={{
                    add: (e) => { saveLayerState('layer_crossroad', 1) },
                    remove: (e) => { saveLayerState('layer_crossroad', 0) }
                }}>
                    {/* <MarkerMuster maxClusterRadius={4} animate > */}
                    <MarkersCrossroad hosts={hosts.crossroad} notify={props.notify} roles={props.roles} />
                    {/* </MarkerMuster> */}

                </LayerGroup>
            </LayersControl.Overlay>
            {props.roles && !props.roles.includes('cafap_cr') &&
                <>

                    <LayersControl.Overlay name="Скоростные" checked={layers.layer_speed === 1}>
                        <LayerGroup eventHandlers={{
                            add: (e) => { saveLayerState('layer_speed', 1) },
                            remove: (e) => { saveLayerState('layer_speed', 0) }
                        }}>
                            {/* <MarkerMuster maxClusterRadius={15} iconCreateFunction={createClusterCustomIconForSpeed} animate> */}
                            <MarkersSpeed hosts={hosts.speed} notify={props.notify} roles={props.roles} />
                            {/* </MarkerMuster> */}


                        </LayerGroup>
                    </LayersControl.Overlay>

                    <LayersControl.Overlay name="Парковка" checked={layers.layer_parking === 1}>
                        <LayerGroup eventHandlers={{
                            add: (e) => { saveLayerState('layer_parking', 1) },
                            remove: (e) => { saveLayerState('layer_parking', 0) }
                        }}>
                            {/* <MarkerMuster maxClusterRadius={1} animate > */}
                            <MarkersParking hosts={hosts.parking} notify={props.notify} roles={props.roles} />
                            {/* </MarkerMuster> */}

                        </LayerGroup>
                    </LayersControl.Overlay>

                    <LayersControl.Overlay name="Весогабарит" checked={layers.layer_vgk === 1}>
                        <LayerGroup eventHandlers={{
                            add: (e) => { saveLayerState('layer_vgk', 1) },
                            remove: (e) => { saveLayerState('layer_vgk', 0) }
                        }}>
                            {/* <MarkerMuster maxClusterRadius={1} animate > */}
                            <MarkersVgk hosts={hosts.vgk} notify={props.notify} roles={props.roles} />
                            {/* </MarkerMuster> */}

                        </LayerGroup>
                    </LayersControl.Overlay>

                    {props.roles && !['cafap_cr', 'manager'].find(role => props.roles.includes(role)) &&
                        <LayersControl.Overlay name="Деактивированные" checked={layers.layer_deact === 1}>
                            <LayerGroup eventHandlers={{
                                add: (e) => { saveLayerState('layer_deact', 1) },
                                remove: (e) => { saveLayerState('layer_deact', 0) }
                            }}>
                                <MarkersDeactivated hosts={hosts.deactivated} roles={props.roles} />
                            </LayerGroup>
                        </LayersControl.Overlay>
                    }
                    {props.roles && !['cafap_cr', 'manager'].find(role => props.roles.includes(role)) &&
                        <LayersControl.Overlay name="Транспорт" checked={layers.layer_vehicles === 1}>
                            <LayerGroup eventHandlers={{
                                add: (e) => { saveLayerState('layer_vehicles', 1) },
                                remove: (e) => { saveLayerState('layer_vehicles', 0) }
                            }}>
                                <MarkersVehicle vehicles={vehicles} roles={props.roles} />
                            </LayerGroup>
                        </LayersControl.Overlay>
                    }
                </>
            }
        </LayersControl>

    );
};

export default ControlLayer;
